import React from "react";
import { Box, Container, Typography, IconButton } from "@mui/material";
import TwitterIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const RegFooter = ({ templateSettings }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      component="footer"
      sx={{
        background: "#FBEDC7",
        padding: 2,
        borderRadius: 1,
        py: 3,
        mt: "auto",
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{ mb: isMobile ? 2 : 0, textAlign: isMobile ? "center" : "left" }}
        >
          <img
            src={templateSettings?.footerBanner ?? ""}
            alt="Ad"
            style={{ maxWidth: isMobile ? "320px" : "480px", height: "auto" }}
          />
        </Box>
        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h6" gutterBottom>
            <a href={templateSettings?.footerLinks?.siteLink ?? "#"}>
              {templateSettings?.footerLinks?.siteName ?? "Site Name"}
            </a>
          </Typography>
          <Box>
            <IconButton href={templateSettings?.footerLinks?.x ?? "#"}>
              <TwitterIcon style={{ color: "#000" }} />
            </IconButton>
            <IconButton href={templateSettings?.footerLinks?.fb ?? "#"}>
              <FacebookIcon style={{ color: "#1877F2" }} />
            </IconButton>
            <IconButton href={templateSettings?.footerLinks?.ln ?? "#"}>
              <LinkedInIcon style={{ color: "#0077B5" }} />
            </IconButton>
            <IconButton href={templateSettings?.footerLinks?.in ?? "#"}>
              <InstagramIcon style={{ color: "#E4405F" }} />
            </IconButton>
          </Box>
        </Box>
        <Box
          sx={{
            mt: isMobile ? 2 : 0,
            textAlign: isMobile ? "center" : "right",
          }}
        >
          <img
            src={templateSettings?.footerLogo ?? ""}
            alt="App Logo"
            style={{ maxWidth: isMobile ? "170px" : "300px", height: "auto" }}
          />
        </Box>
      </Container>
    </Box>
  );
};
export default RegFooter;
